export enum ApiStatus {
    NONE,
    LOADING,
    SUCCESS,
    ERROR
}